<template>
  <a class="accessibility" href="#main">Skip to Content</a>
  <noscript>
    <div>Javascript must be enabled for the correct page display</div>
  </noscript>
  <div class="wrapper" :class="{ 'wrapper--mobile-shell': isMobile }">
    <div class="content-wrap">
      <NavBar v-if="!isMobile" />
      <main class="main content-holder" id="main">
        <TopBar v-if="!isMobile" />
        <template v-else-if="mobileChrome">
          <AppInstallBanner v-if="showAppPromo" />
          <MobileTopBar :title="mobileTitle">
            <template #actions><slot name="mobile-actions"></slot></template>
          </MobileTopBar>
        </template>
        <slot />
      </main>
    </div>
    <PageFooter v-if="!isMobile" />
    <MobileTabBar v-if="isMobile && mobileChrome" />
    <MobileRecordSheet v-if="isMobile && mobileChrome" />
    <AppInstallSheet v-if="showAppPromo" />
  </div>
  <PopupContainer></PopupContainer>
</template>

<script>
import PageFooter from "@/components/PageFooter.vue";
import NavBar from "@/components/navigation/NavBar.vue";
import TopBar from "@/components/TopBar.vue";
import PopupContainer from "@/components/PopupContainer.vue";
import MobileTopBar from "@/components/mobile-shell/MobileTopBar.vue";
import MobileTabBar from "@/components/mobile-shell/MobileTabBar.vue";
import MobileRecordSheet from "@/components/mobile-shell/MobileRecordSheet.vue";
import AppInstallBanner from "@/components/mobile-shell/AppInstallBanner.vue";
import AppInstallSheet from "@/components/mobile-shell/AppInstallSheet.vue";
import { useIsMobile } from "@/composables/useIsMobile";
import { bumpSessionCount } from "@/utils/app-promo";

import { useWorkSpaceStore } from "@/stores/workspace-store";
import { useAppStore } from "@/stores/app-store";
import { mapStores } from "pinia";
import { getUser } from "@/services/workspace.service";

export default {
  name: "PageLayout",
  components: {
    PageFooter,
    NavBar,
    TopBar,
    PopupContainer,
    MobileTopBar,
    MobileTabBar,
    MobileRecordSheet,
    AppInstallBanner,
    AppInstallSheet,
  },
  props: {
    // Detail screens (e.g. the transcript view) bring their own compact
    // header and hide the shell's top/tab bars in one go.
    mobileChrome: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const { isMobile } = useIsMobile();
    return { isMobile };
  },
  created() {
    if (this.isMobile) {
      bumpSessionCount();
    }
  },
  computed: {
    ...mapStores(useAppStore),
    ...mapStores(useWorkSpaceStore),
    // Shell knowledge lives on the routes (router meta), not in per-file
    // route-name lists.
    mobileTitle() {
      return this.$route?.meta?.mobileTitle || "";
    },
    /**
     * App promotion (banner + returning-user sheet) shows on the Library
     * surfaces only — never on detail, account, or public share pages.
     */
    showAppPromo() {
      return this.isMobile && !!this.$route?.meta?.appPromo;
    },
  },
  data() {
    return {
      greeting: "Hello from parent",
    };
  },
  async beforeMount() {
    console.log("PageLayout Mounted");
    try {
      const user = await getUser();
      // getUser resolves an HTTP failure as { data: null, error } rather than
      // throwing. Only a real answer may replace the user: overwriting a good
      // one with null breaks the uploader's userUUID and blanks Account.
      if (user?.data && !user.error) {
        this.appStore.user = user.data;
      } else {
        console.error("Failed to fetch user:", user?.error);
      }

      // // Fetch workspaces if not already loaded
      // if (!this.workspaceStore.workspacesLoaded) {
      //   await this.workspaceStore.fetchWorkspaces();
      // }
    } catch (error) {
      console.error("Failed to fetch user:", error);
      // Continue rendering even if user fetch fails
    }
  },
};
</script>
